import React from 'react';
import { Stack } from 'react-bootstrap';
import { PiForkKnifeFill, PiStarFill } from 'react-icons/pi';
import { Link } from 'react-router-dom';
import { LessonPlanItem } from '../../../utils/lessonPlanUtils';

interface LessonPlansCellProps {
  lessonPlans: LessonPlanItem[];
  featuredLessonPlans?: LessonPlanItem[];
}

export const LessonPlansCell: React.FC<LessonPlansCellProps> = ({
  lessonPlans,
  featuredLessonPlans
}) => {
  return (
    <Stack gap={1}>
      {featuredLessonPlans?.map((plan) => (
        <Link
          to={`../../../../lesson-plans/${plan.slug ?? plan.id}`}
          className="text-info"
        >
          <Stack
            key={plan.id}
            direction="horizontal"
            gap={1}
          >
            <PiStarFill
              size={35}
              className="text-info"
            />
            <span>{plan.name}</span>
          </Stack>
        </Link>
      ))}
      {lessonPlans.map((plan) => (
        <Link
            to={`../../../../lesson-plans/${plan.slug ?? plan.id}`}
            className="text-info"
        >
          <Stack
            key={plan.id}
            direction="horizontal"
            gap={1}
          >
            <PiForkKnifeFill
              size={45}
              className="text-info"
            />
            <span>{plan.name}</span>
          </Stack>
        </Link>
      ))}
    </Stack>
  );
};
